import React from 'react';
import { createRoot } from 'react-dom/client';

import ObjectVideoModal from '@/components/Modals/ObjectVideoModal';

interface VideoModalOptions {
  elementId: string;
  buttonId: string;
  videoUrl: string;
}

const initVideoModal = (options: VideoModalOptions): void => {
  const container = document.querySelector(options.elementId);

  if (!container) {
    return;
  }

  const root = createRoot(container);

  root.render(
    <ObjectVideoModal
      buttonId={options.buttonId}
      videoUrl={options.videoUrl}
    />
  );
};

export default initVideoModal;
